var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"header-buttons md-hidden"},[_c('li',[_c('nuxt-link',{staticClass:"btn btn--small",attrs:{"to":"/internet-bank"}},[_vm._v("\n      Интернет-банк\n      "),_c('svg',{attrs:{"width":"20","height":"20","aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-login"}})])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }